import { Component, OnInit } from '@angular/core';
import { Message } from 'src/app/models/message';
import { Tematic } from 'src/app/models/obs/tematic';
import { Tier3 } from 'src/app/models/obs/tier3';
import { AccessService } from 'src/app/services/access.service';
import { TematicService } from 'src/app/services/obs/tematic.service';
import { Tier3Service } from 'src/app/services/obs/tier3.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';

@Component({
  selector: 'app-admprimaryforce-list',
  templateUrl: './admprimaryforce-list.component.html',
  styleUrl: './admprimaryforce-list.component.scss'
})
export class AdmprimaryforceListComponent implements OnInit {

  result: any;
  tematic: Tematic[];
  t3: Tier3[];
  t3Selected: Tier3;
  msg: Message = null;
  selectedItem: any;
  selectedT1: string = null;

  constructor(
    private tematicS: TematicService,
    private t3S: Tier3Service,
    private accesService: AccessService,
    private ts: TokenStorageService
  ) { }

  ngOnInit() {
    this.selectedT1 = "20";
    this.getTematics();
    this.getT34t1(this.selectedT1);
    this.getPermission();
  }

  //bandera que controla la creacion de contenido
  accessMP: boolean = false
  //bandera que controla la eliminacion de contenido
  accessME: boolean = false
  //bandera que controla la eliminacion de contenido
  accessMD: boolean = false
  /* Permite determinar si el usuario actual tiene permiso para el modulo */
  inf = {}
  getPermission() {
    this.inf['userId'] = this.ts.getUser().id;
    this.inf['accessId'] = 9;// modulo duerzas primarias
    const data = this.inf;
    this.accesService.getPermissionUser(data).subscribe({
      next: res => {
        this.accessMP = res['result'].create;
        this.accessME = res['result'].edit;
        this.accessMD = res['result'].del;
      },
      error: err => {
        this.msg = err;
      }
    });
  }

  getT34t1(id: string) {
    this.t3S.get4t1adm(id).subscribe({
      next: res => {
        this.result = res
        this.t3 = res['data'];
        this.orderForCode(this.t3);
        this.coloredForces(this.t3);
      },
      error: err => {
        this.msg = err;
      }
    });
  }

  orderForCode(t3: Tier3[]) {
    let n = t3.length;
    for (let i = 0; i < n; i++) {
      for (let j = 0; j < n - 1; j++) {
        if (+t3[j].code.replace(/^./, "") > +t3[j + 1].code.replace(/^./, "")) {
          const temp = t3[j];
          t3[j] = t3[j + 1];
          t3[j + 1] = temp;
        }
      }
    }
  }

  coloredForces(t3: Tier3[]) {
    t3.forEach(o => {
      this.tematic.forEach(tem => {
        if (o.idtematic == tem.id) {
          o.tematic = tem.title;
          o.color = tem.color;
        }
      });
    });
  }

  getTematics() {
    this.tematicS.getAll().subscribe({
      next: res => {
        this.result = res
        this.tematic = res['data'];
      },
      error: err => {
        this.msg = err;
      }
    });
  }

  changeTrend(id: string) {
    this.selectedItem = id;
    this.getT34t1(id);
  }

}
